export const PLACEMENT_BOTTOM_RIGHT = "bottom-right";
